document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-sgs-gallery]').forEach(function (gallery) {
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');

    if (!slides.length) return;

    var activeIndex = slides.findIndex(function (slide) {
      return slide.classList.contains('is-active');
    });

    if (activeIndex < 0) activeIndex = 0;
// var counter = gallery.querySelector('[data-gallery-counter]');

    function showSlide(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      activeIndex = index;

      slides.forEach(function (slide, i) {
        var isActive = i === activeIndex;
        slide.hidden = !isActive;
        slide.classList.toggle('is-active', isActive);
      });

      thumbs.forEach(function (thumb, i) {
        var isActive = i === activeIndex;
        thumb.classList.toggle('is-active', isActive);
        if (isActive && typeof thumb.scrollIntoView === 'function') {
          thumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      });

  //     if (counter) {
  //   counter.textContent = (activeIndex + 1) + " / " + slides.length;
  // }

    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        showSlide(index);
      });
    });

    if (prev) {
      prev.addEventListener('click', function () {
        showSlide(activeIndex - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        showSlide(activeIndex + 1);
      });
    }

    showSlide(activeIndex);
  });
});


document.addEventListener("DOMContentLoaded", () => {
  const images = document.querySelectorAll(".sgs-gallery__image");
  const lightbox = document.getElementById("sgsLightbox");
  const lightboxContent = document.getElementById("lightboxContent");
  const closeBtn = document.getElementById("lightboxClose");
  const nextBtn = document.getElementById("lightboxNext");
  const prevBtn = document.getElementById("lightboxPrev");

  let currentIndex = 0;
  let imageArray = [];

  // 🔢 Counter element
  const counter = document.createElement("div");
  counter.className = "sgs-lightbox__counter";
  lightbox.appendChild(counter);

  // Collect images
  images.forEach((img, index) => {
    imageArray.push(img.src);

    img.addEventListener("click", () => {
      currentIndex = index;
      showImage();
      lightbox.classList.add("active");
    });
  });

  function showImage() {
    lightboxContent.innerHTML = `
      <div class="sgs-lightbox__zoom-wrap">
        <img src="${imageArray[currentIndex]}" class="sgs-lightbox__image" />
      </div>
    `;

    // ✅ Update counter
    counter.textContent = `${currentIndex + 1} / ${imageArray.length}`;

    // 🔍 Zoom effect (mouse follow)
    const img = lightboxContent.querySelector("img");

    img.addEventListener("mousemove", (e) => {
      const rect = img.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;

      img.style.transformOrigin = `${x}% ${y}%`;
      img.style.transform = "scale(2)";
    });

    img.addEventListener("mouseleave", () => {
      img.style.transform = "scale(1)";
    });
  }

  // ➡️ Next
  nextBtn.addEventListener("click", () => {
    currentIndex = (currentIndex + 1) % imageArray.length;
    showImage();
  });

  // ⬅️ Prev
  prevBtn.addEventListener("click", () => {
    currentIndex = (currentIndex - 1 + imageArray.length) % imageArray.length;
    showImage();
  });

  // ❌ Close
  closeBtn.addEventListener("click", () => {
    lightbox.classList.remove("active");
  });

  // Click outside to close
  lightbox.addEventListener("click", (e) => {
    if (e.target === lightbox) {
      lightbox.classList.remove("active");
    }
  });

  // ⌨️ Keyboard support
  document.addEventListener("keydown", (e) => {
    if (!lightbox.classList.contains("active")) return;

    if (e.key === "ArrowRight") nextBtn.click();
    if (e.key === "ArrowLeft") prevBtn.click();
    if (e.key === "Escape") lightbox.classList.remove("active");
  });
});

document.addEventListener('DOMContentLoaded', function () {

  const container = document.querySelector('.sgs-product');
  const sectionId = container?.dataset.sectionId;

  if (!sectionId) return;

  const qtyInput = document.getElementById(`Quantity-${sectionId}`);
  const errorBox = document.getElementById(`qty-error-${sectionId}`);
  const form = document.getElementById(`product-form-${sectionId}`);
  const stockInput = document.getElementById(`variant-stock-${sectionId}`);

  // ❗ prevent crash
  if (!qtyInput) return;
function getMaxQty() {
  let stock = parseInt(stockInput?.value);

  // Fix negative or invalid stock
  if (isNaN(stock) || stock < 1) return 1;

  return stock;
}

  function showError(msg) {
    if (!errorBox) return;
    errorBox.style.display = 'block';
    errorBox.textContent = msg;
  }

  function clearError() {
    if (!errorBox) return;
    errorBox.style.display = 'none';
    errorBox.textContent = '';
  }

  function normalizeValue(val) {
    let num = parseInt(val);

if (isNaN(num) || num < 1) {
  clearError();
  return 1;
}
    let maxQty = getMaxQty();

    if (num > maxQty) {
      showError(`Only ${maxQty} item(s) available`);
      return maxQty;
    }

    clearError();
    return num;
  }

  function validateAndFix() {
    qtyInput.value = normalizeValue(qtyInput.value);
  }

  qtyInput.addEventListener('input', validateAndFix);
  qtyInput.addEventListener('blur', validateAndFix);

  if (form) {
    form.addEventListener('submit', function (e) {
      let fixed = normalizeValue(qtyInput.value);
      qtyInput.value = fixed;

      if (parseInt(qtyInput.value) !== fixed) {
        e.preventDefault();
      }
    });
  }

});

document.addEventListener('DOMContentLoaded', function () {

  // --- GALLERY ---
  document.querySelectorAll('[data-sgs-gallery]').forEach(function (gallery) {
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    var prev   = gallery.querySelector('[data-gallery-prev]');
    var next   = gallery.querySelector('[data-gallery-next]');
    if (!slides.length) return;
    var activeIndex = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
    if (activeIndex < 0) activeIndex = 0;

    function showSlide(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      activeIndex = index;
      slides.forEach(function (slide, i) {
        var isActive = i === activeIndex;
        slide.hidden = !isActive;
        slide.classList.toggle('is-active', isActive);
      });
      thumbs.forEach(function (thumb, i) {
        var isActive = i === activeIndex;
        thumb.classList.toggle('is-active', isActive);
        if (isActive && typeof thumb.scrollIntoView === 'function') {
          thumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      });
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () { showSlide(index); });
    });
    if (prev) prev.addEventListener('click', function () { showSlide(activeIndex - 1); });
    if (next) next.addEventListener('click', function () { showSlide(activeIndex + 1); });
    showSlide(activeIndex);
  });

  // --- LIGHTBOX ---
  const images         = document.querySelectorAll('.sgs-gallery__image');
  const lightbox       = document.getElementById('sgsLightbox');
  const lightboxContent = document.getElementById('lightboxContent');
  const closeBtn       = document.getElementById('lightboxClose');
  const nextBtn        = document.getElementById('lightboxNext');
  const prevBtn        = document.getElementById('lightboxPrev');
  let currentIndex = 0;
  let imageArray   = [];

  images.forEach(function (img, index) {
    imageArray.push(img.src);
    img.addEventListener('click', function () {
      currentIndex = index;
      showLightboxImage();
      lightbox.classList.add('active');
    });
  });

  function showLightboxImage() {
    lightboxContent.innerHTML = '<img src="' + imageArray[currentIndex] + '" />';
  }

  if (nextBtn) nextBtn.addEventListener('click', function () {
    currentIndex = (currentIndex + 1) % imageArray.length;
    showLightboxImage();
  });
  if (prevBtn) prevBtn.addEventListener('click', function () {
    currentIndex = (currentIndex - 1 + imageArray.length) % imageArray.length;
    showLightboxImage();
  });
  if (closeBtn) closeBtn.addEventListener('click', function () {
    lightbox.classList.remove('active');
  });
  if (lightbox) lightbox.addEventListener('click', function (e) {
    if (e.target === lightbox) lightbox.classList.remove('active');
  });

  // --- PRODUCT FORM ---
  const container    = document.querySelector('.sgs-product');
  const sectionId    = container?.dataset.sectionId;
  if (!sectionId) return;

  const qtyInput     = document.getElementById('Quantity-' + sectionId);
  const errorBox     = document.getElementById('qty-error-' + sectionId);
  const stockInput   = document.getElementById('variant-stock-' + sectionId);
  const addBtn       = document.getElementById('add-to-cart-' + sectionId);
  const inCartBtn    = document.getElementById('in-cart-btn-' + sectionId);
  const qtyBlock     = document.getElementById('qty-block-' + sectionId);
  const variantInput = document.querySelector('[data-current-variant-id]');
  const form         = document.getElementById('product-form-' + sectionId);

  if (!qtyInput) return;

  function getMaxQty() {
    const stock = parseInt(stockInput?.value);
    return isNaN(stock) || stock < 1 ? 1 : stock;
  }

  function showError(msg) {
    if (!errorBox) return;
    errorBox.style.display = 'block';
    errorBox.textContent   = msg;
  }

  function clearError() {
    if (!errorBox) return;
    errorBox.style.display = 'none';
    errorBox.textContent   = '';
  }

  function normalizeValue(val) {
    const num    = parseInt(val);
    const maxQty = getMaxQty();
    if (isNaN(num) || num < 1) { clearError(); return 1; }
    if (num > maxQty) { showError('Only ' + maxQty + ' item(s) available'); return maxQty; }
    clearError();
    return num;
  }

  qtyInput.addEventListener('input', function () { qtyInput.value = normalizeValue(qtyInput.value); });
  qtyInput.addEventListener('blur',  function () { qtyInput.value = normalizeValue(qtyInput.value); });

  // --- SHOW / HIDE in-cart state ---
  function setInCartState(inCart) {
    if (inCart) {
      addBtn.style.display    = 'none';
      // qtyBlock.style.display  = 'none';
      inCartBtn.style.display = 'block';
    } else {
      addBtn.style.display    = '';
      qtyBlock.style.display  = '';
      inCartBtn.style.display = 'block';
    }
  }

  // --- VARIANT CHANGE: re-check cart via fetch (only fires on variant switch) ---
  async function checkCartForVariant() {
    if (!variantInput) return;
    const variantId = parseInt(variantInput.value);
    if (!variantId) return;
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      const found = cart.items.find(function (i) { return i.variant_id === variantId; });
      setInCartState(!!found);
    } catch (err) {
      console.warn('Cart check error:', err);
    }
  }

  // Only fetch on variant change — not on initial load
  document.querySelectorAll('.sgs-product__select').forEach(function (select) {
    select.addEventListener('change', function () {
      // 100ms delay lets Shopify update the hidden variant input first
      setTimeout(checkCartForVariant, 100);
    });
  });

  // --- FORM SUBMIT: AJAX add to cart ---
  if (form) {
    form.addEventListener('submit', async function (e) {
      e.preventDefault();

      const qty       = normalizeValue(qtyInput.value);
      qtyInput.value  = qty;
      const variantId = parseInt(variantInput.value);
      const maxStock  = getMaxQty();

      // Stock check
      if (qty > maxStock) {
        showError(maxStock <= 0
          ? 'This item is out of stock.'
          : 'Only ' + maxStock + ' available. Please reduce quantity.'
        );
        return;
      }

      // Optimistic UI — show loading state immediately
      addBtn.disabled    = true;
      addBtn.textContent = 'Adding...';
      clearError();

      try {
        const res  = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty })
        });
        const data = await res.json();

        // Shopify rejected it
        if (data.status && data.status !== 200) {
          showError(data.description || 'Could not add to cart.');
          addBtn.disabled    = false;
          addBtn.textContent = addBtn.dataset.label || 'Add to cart';
          return;
        }

        // Success — swap to in-cart state immediately, no second fetch
        setInCartState(true);

        // Update header cart count if present
        const countEls = document.querySelectorAll('[data-cart-count]');
        if (countEls.length) {
          const cartRes  = await fetch('/cart.js');
          const cartData = await cartRes.json();
          countEls.forEach(function (el) { el.textContent = cartData.item_count; });
        }

      } catch (err) {
        console.warn('Add to cart error:', err);
        showError('Something went wrong. Please try again.');
        addBtn.disabled    = false;
        addBtn.textContent = addBtn.dataset.label || 'Add to cart';
      }
    });
  }
});

